import { Box, Text } from "@nulogy/components";
import { formatQuantity } from "components/helpers/format";
import Schedule from "domain/Schedule";
import React from "react";

export default function ExpectedUnits({ workBlock, workTimeStartsAt, workTimeEndsAt }) {
  return (
    <Box data-testid="expected-units" fontSize="smaller" lineHeight="smallerText" paddingTop="x1">
      <Text color="midGrey" fontSize="smaller" inline lineHeight="smallerText">
        Expected block quantity:{" "}
      </Text>
      <Text fontSize="smaller" fontWeight="medium" inline lineHeight="smallerText">
        {formatQuantity(Schedule.resizedQuantity(workBlock, workTimeStartsAt, workTimeEndsAt))}{" "}
        {workBlock.unitOfMeasure}
      </Text>
    </Box>
  );
}
